import React, { useState } from 'react'
import GgGolfHubPopup from '../shared/gg_golf_hub_popup'
import { GGInput } from '../../../shared/new_components/GGInput'
import PropTypes from 'prop-types'
import { isValidEmail } from '../../../shared/helpers'

const AddManagerPopup = ({ isOpen, isSubmitting, handleAddManager, handleOnClose }) => {
  const [ firstName, setFirstName ] = useState('')
  const [ lastName, setLastName ] = useState('')
  const [ email, setEmail ] = useState('')

  const isConfirmDisabled = isSubmitting || !(firstName && lastName && isValidEmail(email))
  return (
    <GgGolfHubPopup
      isOpen={isOpen}
      title={window.I18n.t('gg_golf_hub.add_manager_popup.add_manager')}
      onConfirm={() => handleAddManager(firstName, lastName, email)}
      onClose={handleOnClose}
      isConfirmDisabled={isConfirmDisabled}
      >
      <GGInput name='first_name' label={window.I18n.t('gg_golf_hub.add_manager_popup.first_name')} value={firstName} onChange={setFirstName} />
      <div className='add-margin-top-10'/>
      <GGInput name='last_name' label={window.I18n.t('gg_golf_hub.add_manager_popup.last_name')} value={lastName} onChange={setLastName} />
      <div className='add-margin-top-10'/>
      <GGInput name='email' label={window.I18n.t('gg_golf_hub.add_manager_popup.email_address')} value={email} onChange={setEmail} />
    </GgGolfHubPopup>
  )
}

AddManagerPopup.propTypes = {
  isOpen: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleAddManager: PropTypes.func,
  handleOnClose: PropTypes.func,
}

export default AddManagerPopup
